var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tagcloud"},_vm._l((_vm.tags),function(tag,index){return _c('router-link',{key:`${tag.slug}-${index}`,attrs:{"to":`/tag/${tag.slug}`}},[_vm._v(" "+_vm._s(_vm.$t('Blog.tags.' + tag.title))+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }